import { Fragment } from "react";
import InputField from "./InputFieldWrapper";
import MmvCard from "./mmvCard";
import SelectButton from "./selectButton";
import PageHeading from "./PageHeading";
import QnaHeading from "./qnaHeading";
import Footer from "./footer";
import BoxContainer from "./boxContainer";
import EditWidget from "./editWidget";
import LeftNavigation from "./leftNavigation";
import Header from "./header";
import FlexContainer from "./flexContainer";
import DropDown from "@components/dropdown";
import Calendar from "@components/calendar";
import Button from "./button";
// import MMVDetails from '@components/mmvDetails';
import DiscountCard from "./discountCard";
import CouponCard from "./couponCard";
import DiscountBanner from "./discountBanner";
// import InputDropdown from './inputDropdown';
import MmvContainer from "./mmvContainer";
// import MMVDetails from '@components/mmvDetails';
import MmvInputField from "@components/mmvInputField";
import NcbInputField from "@components/NcbInputField";
import Modal from "@components/modal";
import PrimaryButton from "./PrimaryButton";
import Typography from "./typography";
import ImageContainer from "@components/imageContainer";
import AddOnCard from "./addonCard";
import FooterData from "./footerData/index";
import flexBox from "./flexBox";
import PremiumBreakUp from "./premiumBreakUp";
import ExpandableCard from "./ExpandableCard";
import VehicleDetails from "./VehicleDetails";

import PlansContainer from "@components/plansContainer";
import PlanCard from "@components/planCard";
import SectionDivider from "@components/common/divider";
import HyperLinkText from "@components/common/hyperlink";
import Text from "@components/common/text";
import Container from "@components/common/container";
import Benefits from "@components/benefits";
import HorizontalScroll from "@components/horizontalScroll";
import CoveredNotCoveredAddons from "@components/coveredNotCoveredAddonsSection";
import Banner from "@components/banner";
import PolicyStatusCard from "@components/policyStatusCard";
import Badge from "@components/common/badge";
import AddonUpgradeCard from "@components/addonUpgradeCard";
import FooterPrice from "@components/footerPrice";
import AddonVariantModals from "@components/addonVariantModals";
import RadioSelection from "@components/common/radioSelection";
import ModalStickyFooter from "./modalStickyFooter";
import AddonsUpgradeContainer from "@components/addonUpgradesContainer";
import InspectionItems from "@components/InspectionItems";
import PremiumReductionBanner from "@components/PremiumReductionBanner";
import IdvSection from "@components/idvSection";
import PageHeadingWithImage from "./pageHeadingWithImage";
import DidYouKnowAddon from "./didYouKnowAddon";
import PaymentData from "./PaymentData";

import IdvContainer from "@components/IdvContainer";
import IdvInfoMessage from "@components/IdvContainer/slider/IdvInfoMessage";
import NewPolicyNudge from "./newPolicyNudge";
import VerifyOtp from "./verifyOtp/verifyOtp";
import HcaptchaPrimaryButton from "./hCaptchaPrimaryButton/primaryCta";
import GarageList from "./garageList";
import GarageCard from "./garageCard";
import { SDUIImageTag } from "@components/common/image";
import NcbBottomSheet from "@components/NcbBottomSheet";
import GradientHeader from "./gradientHeader";
import DynamicLottie from "@components/common/Lottie/LottieAnimation";
import talkToUs from "./talkToUs";
import FloatingIcon from "./floatingIcon";
import NcbUpdateModal from "@components/NcbUpdateModal";
import Error from "@components/Error";
import TermAndCondition from "./termsAndCond";
// import couponCard from "./couponCard";
import MultipleCouponCard from "./multipleCouponCard";
import CoveragePricingBreakup from "./coveragePricingBreakup";
import ModifyIDV from "./modifyIDV";
import ReviewSelectedPlan from "./reviewSelectedPlan";
import ReviewAdditionalCovers from "./reviewAdditionalCovers";
import ReviewPriceBreakup from "./reviewPriceBreakup";
import IDVContainerWithSlider from "./idvContainerWithSlider";
import AddonAccessoryModal from "@components/addonAccessoryModal";
import FastagNudge from "@components/common/fastagNudge";
import FastagInfo from "./FASTagInfo";
import Dashcam from "./dashcam";
import PlanHeading from "./planHeading";
import PlanCardV2 from "./planCardV2";
import PlanBenefits from "./planBenefits";
import Garages from "./garages";
import NavigationTabs from "./navigationTabs";
import DashcamModel from "@components/Dashcam/dashcamModel";
import DashcamFeatures from "@components/Dashcam/dashcamFeatures";
import FeatureTable from "./featureTable";

import PreviewDetails from "./previewDetails";
import CoverageComparison from "./coverageComparison";
import HeadingParagraph from "./headingParagraph";
import PolicyStartDate from "./policyStartDate";
import QWithImageNDesc from "./qWithImageNDesc";
import PolicyTimeline from "./policyTimeline";
import ModifyModal from "./modifyModal";
import CoverageCard from "./coverageCard";
import CheckoutCard from "./checkoutCard";
import PremiumDetails from "./premiumDetails";
import NetworkGarage from "./networkGarage";
import Addon from "./addon";
import EditDetails from "./editDetails";
// import couponCard from "./couponCard";
import UpdateDetailsCard from "./updateDetailsCard";
import PageHeadingWithImageAndDesc from "./pageHeadingWithImageAndDesc";
import RadioSelect from "./radioSelect";
import IdvSelection from "./idvSelection";
import IdvDescription from "./idvDescription";
import EditVariantContainer from "./editVariantContainer";
import MultiYearPlan from "./multiYearPlan";
import TextAreaField from "./textAreaField";
import MmvCardWithExpiry from "./mmvCardWithExpiry";
import PlansTopBanner from "@components/plansTopBanner";
import PlansDetails from "@components/planDetails";
import { PlansBoxContainer } from "@components/PlansBoxContainer";
import PlansBottomBanner from "@components/PlansBottomBanner";
import ViewGaragesCard from "@components/viewGaragesCard";
import IDVModal from "@components/IDVModal";
import ClaimsCarousel from "@components/ClaimsSlides";
import PlansPageHeading from "./PlansPageHeading";
import LandingPageSrollableCardsWithHeading from "./landingPageScrollableCardsWithHeading";
import DealershipLiesGrid from "./DealershipLiesGrid";
import AckoDriveCarousel from "./ackoDriveCarousel";
import NewCarMakeSelection from "./newCarMakeSelection";
import NewCarModelOrFuelTypeSelection from "./newModelOrFuelTypeSelection";
import DealershipDetailsAndSelection from "./dealershipDetailsAndSelection";
import AckoDriveNudgeModal from "./ackoDriveNudgeModal";
import AckoGarageList from "./ackoGarageList";
import AckoDriveNavigationNudgeModal from "./ackoDriveNavigationNudgeModal";
import Lottie from "./lottie";
import AckoGarageUpGradeModalContent from "@components/ackoGarageUpGradeModalContent";
import ZDModal from "@components/zeroDepModal";
import PlanLearnMore from "./planLearnMore";
import CoveredNotCoveredDetails from "./coveredNotCoveredDetails";
import TabNavigation from "./tabNavigation";
import BannerWithListItems from "@components/bannerWithListItems";
import NotSureCard from "./NotSureCard";
import AckoDriveCallbackModal from "./ackoDriveNudgeModal/getCallback";
import AckoSelectGarages from "./ackoSelectGarages";
import plansExtensionHeading from "./plansExtensionHeading";
import planExtensionCardsList, {
  PlanExtensionCard
} from "./planExtensionCardsList";
import DashcamPrivacy from "@components/Dashcam/DashcamPrivacy";
import DashcamAckoApp from "@components/Dashcam/DashcamAckoApp";
import Faqs from "./faq";
import BannerV2 from "./bannerV2";
import CheckoutNoteCard from "./CheckoutNoteCard";
import AddressList from "./AddressList";
import GoogleMap from "./GoogleMap";
import AddressForm from "./AddressForm";
import DetailsAddedLoader from "./DetailsAddedLoader";
import DateSelector from "./dateSelector";
import TimeSlotSelector from "./timeSlotSelector";
import ScheduleDetailsCard from "./scheduleDetailsCard";
import CarLocationCard from "./carLocationCard";
import TrackingDetailsCard from "./trackingDetailsCard";
import DeliveryTimeline from "./deliveryTimeline";
import DeliveryDetailsCard from "./deliveryDetailsCard";
import PrimaryButtonWithDisabled from "./PrimaryButtonWithDisabled";
import AppointmentConfirmedLoader from "./AppointmentConfirmedLoader";
import HeaderInLayouts from "./headerInLayouts";
import EditableInfoItem from "./editableInfoItem";
import ActivationSelectionCard from "./activationSelectionCard";
import ImgWithTextDesc from "./ImgWithTextDesc";
import MicroSDModal from "@components/MicroSDModal";
import { IsCommercialCar } from "@components/IsCommercial";

const widgetsMap = {
  fragment: Fragment,
  page_heading: PageHeading,
  layout: BoxContainer,
  mmv_widget: MmvCard,
  select_button: SelectButton,
  qna: QnaHeading,
  input: InputField,
  inputfield: InputField,
  edit_widget: EditWidget,
  left_navigation: LeftNavigation,
  header: Header,
  flex_container: FlexContainer,
  dropdown: DropDown,
  calendar: Calendar,
  footer: Footer,
  primary_button: Button,
  policy_start_date: PolicyStartDate,
  heading_with_paragraph: HeadingParagraph,
  policy_timeline: PolicyTimeline,
  modify_modal: ModifyModal,
  coverage_card: CoverageCard,
  policy_status_card: PolicyStatusCard,
  checkout_card: CheckoutCard,
  premium_details: PremiumDetails,
  network_garage: NetworkGarage,
  addon: Addon,
  edit_details: EditDetails,
  update_details_card: UpdateDetailsCard,
  page_heading_with_image_and_desc: PageHeadingWithImageAndDesc,
  radio_select: RadioSelect,
  idv_description: IdvDescription,
  //   input_dropdown: InputDropdown,
  mmv_container: MmvContainer,
  // "mmv_details": MMVDetails,
  mmv_input_field: MmvInputField,
  discount_card: DiscountCard,
  coupon_card: CouponCard,
  discount_banner: DiscountBanner,
  // "input_dropdown": InputDropdown,
  // "mmv_details": MMVDetails,
  ncbInputField: NcbInputField,
  bottomsheet: Modal,
  modal_primary_button: PrimaryButton,
  typography: Typography,
  // typography: SDUIText,
  image_container: ImageContainer,
  addon_card: AddOnCard,
  footer_data: FooterData,
  FlexBox: flexBox,
  premium_breakup: PremiumBreakUp,
  // "input_dropdown": InputDropdown,
  // "mmv_details": MMVDetails,
  plans_container: PlansContainer,
  plan_card: PlanCard,
  section_divider: SectionDivider,
  hyperlink_text: HyperLinkText,
  text: Text,
  box_container: Container,
  benefits: Benefits,
  horizontal_scroll: HorizontalScroll,
  covered_not_covered_addons: CoveredNotCoveredAddons,
  banner: Banner,
  addon_upgrade_card: AddonUpgradeCard,
  footer_price: FooterPrice,
  addon_variants_modal: AddonVariantModals,
  badge: Badge,
  radio_selection: RadioSelection,
  page_heading_with_image: PageHeadingWithImage,
  question_with_imagedescription: QWithImageNDesc,
  // "mmv_details": MMVDetails,
  addons_upgrade_container: AddonsUpgradeContainer,
  idv_section: IdvSection,
  idv_container: IdvContainer,
  idv_info_message: IdvInfoMessage,
  did_you_know_addon: DidYouKnowAddon,

  preview_details: PreviewDetails,
  coverage_comaprison: CoverageComparison,
  idv_selection: IdvSelection,
  textarea: TextAreaField,
  expandable_card: ExpandableCard,
  vehicle_details: VehicleDetails,
  inspection_items: InspectionItems,
  premium_reduction_banner: PremiumReductionBanner,
  policy_start_date_nudge: NewPolicyNudge,
  verify_otp: VerifyOtp,
  hcaptcha_primary_button: HcaptchaPrimaryButton,
  image: SDUIImageTag,
  garage_list: GarageList,
  garage_card: GarageCard,
  ncb_bottomsheet: NcbBottomSheet,
  payment_data: PaymentData,
  gradient_header: GradientHeader,
  lottie: DynamicLottie,
  talk_to_us: talkToUs,
  floating_call_icon: FloatingIcon,
  ncb_update_modal: NcbUpdateModal,
  error_page: Error,
  terms_condition: TermAndCondition,
  modal_sticky_footer: ModalStickyFooter,
  multiple_copuons_card: MultipleCouponCard,
  coverage_pricing_breakup: CoveragePricingBreakup,
  modify_idv: ModifyIDV,
  review_selected_plan: ReviewSelectedPlan,
  review_additional_covers: ReviewAdditionalCovers,
  review_price_breakup: ReviewPriceBreakup,
  edit_variant_container: EditVariantContainer,
  idv_container_with_slider: IDVContainerWithSlider,
  addon_accessory_modal: AddonAccessoryModal,
  fastag_info: FastagInfo,
  fastag_nudge: FastagNudge,
  endorsement_footer: MultiYearPlan,
  tab_navigation: TabNavigation,
  navigation_tabs: NavigationTabs,
  zd_modal: ZDModal,
  covered_not_covered_details: CoveredNotCoveredDetails,
  plan_learn_more: PlanLearnMore,
  banner_with_list_items: BannerWithListItems,
  not_sure_card: NotSureCard,
  adzd_content: AckoGarageUpGradeModalContent,
  mmv_card_with_expiry: MmvCardWithExpiry,
  plans_top_banner: PlansTopBanner,
  plan_details: PlansDetails,
  plans_box_container: PlansBoxContainer,
  plans_bottom_banner: PlansBottomBanner,
  view_garages_card: ViewGaragesCard,
  edit_idv: IDVModal,
  claims_carousel: ClaimsCarousel,
  plans_page_heading: PlansPageHeading,
  landing_page_scrollable_cards_with_heading:
  LandingPageSrollableCardsWithHeading,
  dealership_lies_grid: DealershipLiesGrid,
  acko_drive_carousel: AckoDriveCarousel,
  new_car_make_selection: NewCarMakeSelection,
  new_car_model_or_fuel_type_selection: NewCarModelOrFuelTypeSelection,
  dealership_details_and_selection: DealershipDetailsAndSelection,
  acko_drive_nudge_modal: AckoDriveNudgeModal,
  acko_drive_callback_modal: AckoDriveCallbackModal,
  acko_garage_list: AckoGarageList,
  acko_drive_navigation_nudge_modal: AckoDriveNavigationNudgeModal,
  lottie_player: Lottie,
  acko_select_garages: AckoSelectGarages,
  plans_extension_heading: plansExtensionHeading,
  plan_extension_cards_list: planExtensionCardsList,
  plan_extension_cards: PlanExtensionCard,
  dashcam_intro_page: Dashcam,
  plans_container_heading: PlanHeading,
  plan_card_v2: PlanCardV2,
  plan_benefits: PlanBenefits,
  garages_container: Garages,
  dashcam_model: DashcamModel,
  dashcam_features: DashcamFeatures,
  feature_table: FeatureTable,
  dashcam_privacy_card: DashcamPrivacy,
  dashcam_acko_app_card: DashcamAckoApp,
  faqs: Faqs,
  banner_v2: BannerV2,
  checkout_note_card: CheckoutNoteCard,
  address_list: AddressList,
  google_map: GoogleMap,
  address_form: AddressForm,
  details_added_loader: DetailsAddedLoader,
  date_selector: DateSelector,
  time_slot_selector: TimeSlotSelector,
  schedule_details_card: ScheduleDetailsCard,
  car_location_card: CarLocationCard,
  tracking_details_card: TrackingDetailsCard,
  delivery_timeline: DeliveryTimeline,
  delivery_details_card: DeliveryDetailsCard,
  primary_button_with_disabled: PrimaryButtonWithDisabled,
  appointment_confirmed_loader: AppointmentConfirmedLoader,
  header_in_layouts: HeaderInLayouts,
  editable_info_item: EditableInfoItem,
  activation_selection_card: ActivationSelectionCard,
  img_with_text_desc: ImgWithTextDesc,
  micro_sd_modal: MicroSDModal,
  is_commercial_qna: IsCommercialCar,
};

export default widgetsMap;
